import _ from 'underscore';

const leftOffsetUINext = 392;
const leftOffsetMccUINext = 164;
const dashboardTopUINext = 205;
const cardMargin = 16;
const subPageMarginsForUINext = 30;

export const newUIWidthPaddingsAndOffSet = 35;

export function getViewportCardCount({
  config,
  cards,
  constants,
  instrumentation,
  isMccLevel,
}) {
  // Only one tile available for welcome tips
  if (config.defaultName === 'welcome') {
    return 1;
  }

  const topOffset = dashboardTopUINext;
  const leftOffset = isMccLevel ? leftOffsetMccUINext : leftOffsetUINext;
  const bottomOffset = 0;
  const subPageMargins = subPageMarginsForUINext;

  const availableWidth = window.innerWidth - leftOffset - subPageMargins -
    newUIWidthPaddingsAndOffSet;

  // From the error logs we have rare cases where users window.innerWidth returns 0.
  // In that case, only preload one tile.
  if (availableWidth <= 0) {
    return 1;
  }

  const layoutOption = _.chain(config.layoutOptions)
    .filter(option => option.breakpoint < availableWidth)
    .max(option => option.breakpoint)
    .value();
  const optionKey = _.findKey(config.layoutOptions, option => _.isEqual(option, layoutOption));
  const initialRowCount = Math.round((window.innerHeight - topOffset - bottomOffset) /
    (layoutOption.defaultHeight + cardMargin));
  const rowSize = layoutOption.maxCardSize;
  let remainingRowCount = initialRowCount;
  let currentRowRemainingSpace = rowSize;

  if (remainingRowCount === 0) {
    return 0;
  }

  // We have cards with different sizes.
  // count how many we can fit in based on space and card size.
  try {
    for (let index = 0; index < cards.length; index += 1) {
      const cardSize = cards[index].sizeOption[optionKey].width;

      if (currentRowRemainingSpace < cardSize) {
        remainingRowCount -= 1;
        if (remainingRowCount === 0) {
          return index;
        }
        currentRowRemainingSpace = rowSize - cardSize;
      } else {
        currentRowRemainingSpace -= cardSize;
      }
    }
  } catch (ex) {
    const state = {
      leftOffset,
      innerWidth: window.innerWidth,
      initialRowCount,
      remainingRowCount,
      layoutOptions: config.layoutOptions,
      layoutOption,
      optionKey,
      cards,
    };

    instrumentation.logMessage([constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.INFO, 'dashboard/util', `${ex.stack}, ${JSON.stringify(state)}`);
    return cards.length;
  }

  return cards.length;
}
